"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var React = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _filterProps = _interopRequireDefault(require("../helpers/filterProps"));
var _memoizeOne = _interopRequireDefault(require("../helpers/memoizeOne"));
var _withBreakpoints = _interopRequireDefault(require("./withBreakpoints"));
var _excluded = ["component"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var globalFilteredKeys = ['debug', 'breakpoints', 'mediaQueries', 'filteredKeys'];
var breakpointPropTypes = ['Offset', 'Order'];
var createBlacklist = function createBlacklist(filteredKeys) {
  return function (props) {
    var blacklist = [].concat(globalFilteredKeys, filteredKeys);
    if ((0, _get.default)(props, 'mediaQueries.keys') == null) {
      return blacklist;
    }
    return [].concat(blacklist, props.mediaQueries.keys.reduce(function (acc, key) {
      acc.push(key);
      breakpointPropTypes.forEach(function (type) {
        return acc.push("" + key + type);
      });
      return acc;
    }, []));
  };
};
var compareKeys = function compareKeys(a, b) {
  return Object.is((0, _get.default)(a, 'mediaQueries.keys'), (0, _get.default)(b, 'mediaQueries.keys'));
};
var createGridComponent = function createGridComponent(id, filteredKeys) {
  var getBlacklist = (0, _memoizeOne.default)(createBlacklist(filteredKeys), compareKeys);
  var GridComponent = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var component = _ref.component,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
    return /*#__PURE__*/React.createElement(component, Object.assign({}, (0, _filterProps.default)(props, getBlacklist(props)), {
      ref: ref
    }));
  });
  GridComponent.defaultProps = {
    component: 'div'
  };
  return (0, _withBreakpoints.default)(GridComponent);
};
var _default = exports.default = createGridComponent;